import React from "react";
import styled from "styled-components/macro";

import { AccountPrimaryFragment, ActiveProfileQuery } from "operations";

const StyledAccountUserDetails = styled.div`
  color: white;
  font-size: 12px;
  font-weight: var(--font-weight-regular);
`;

const label = (account: AccountPrimaryFragment) =>
  `${account.name} (${account.id})`; // TODO: Use formatLabel fn.
const AccountUserDetails = ({
  account,
}: Pick<ActiveProfileQuery, "account">) => (
  <StyledAccountUserDetails>{label(account)}</StyledAccountUserDetails>
);

export default AccountUserDetails;
